<div class="flex flex-col h-screen w-full">
  <app-page-header>
    <div class="flex flex-row justify-start items-center gap-2 h-10">
      <span>{{ create ? 'Projekt erstellen' : 'Projekteinstellungen' }}</span>
    </div>
  </app-page-header>


  @if (!create) {
<div class="flex-1 w-full overflow-y-auto p-6 min-h-0 ">

    <bic-accordion [gapBetweenElements]="0" [openedIndex]=0>
      <bic-accordion-element>
        <bic-accordion-header>
          <div>1. {{ project.name }}</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="generalInfo"></ng-container>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: project address info -->
      <bic-accordion-element>
        <bic-accordion-header>
          <div>2. Projektadresse</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="addressInfo"></ng-container>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: project planning and builder info -->
      <bic-accordion-element>
        <bic-accordion-header>
          <div>3. Zeitplan</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="builderInfo"></ng-container>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: project members info -->
      <bic-accordion-element>
        <bic-accordion-header>
          <div>4. Projektmitglieder</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <div>
            <app-users-list [fromProjectAccordion]="true"
                            [isProject]="true"
                            [organisation]="stateConfigService.getOrganisation()!"
                            [addDisabled]="!hasEditPermission || !permissionService.hasProjectPrivilege('PROJECT_USER_MANAGEMENT')"
                            [deleteDisabled]="!hasEditPermission || !permissionService.hasProjectPrivilege('PROJECT_USER_MANAGEMENT')"
                            [permissionsDisabled]="!hasEditPermission || !permissionService.hasProjectPrivilege('PROJECT_USER_MANAGEMENT')">
            </app-users-list>
          </div>
        </bic-accordion-body>
      </bic-accordion-element>

      <!-- panel: project settings info -->
      <bic-accordion-element>
        <bic-accordion-header>
          <div>5. Prüfeinstellungen</div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="qualitySettingsInfo"></ng-container>
        </bic-accordion-body>
      </bic-accordion-element>

    </bic-accordion>

  </div>
}

  @if (create) {
<div class="flex-1 w-full overflow-y-auto p-6 min-h-0">
    <bic-accordion #accordion [disableManualToggle]="true" [gapBetweenElements]="0" [openedIndex]=0>
      <bic-accordion-element (opened)="expandedElement = 0" (closed)="expandedElement = null">
        <bic-accordion-header>
          <div><span>1. Projektbesitzer*in</span></div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="generalData"></ng-container>
          <div class="flex flex-row justify-end items-center pt-5">
            <bic-button (onClick)="accordion.open(1)"
                        [disabled]="nextDisabledStep1">Weiter
              <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
            </bic-button>
          </div>
        </bic-accordion-body>
      </bic-accordion-element>


      <bic-accordion-element (opened)="expandedElement = 1" (closed)="expandedElement = null">
        <bic-accordion-header>
          <div><span>2. Bauort</span></div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="placeData"></ng-container>
          <div class="flex flex-row justify-end items-center gap-4 pt-5">
            <bic-button (onClick)="accordion.open(0)" buttonType="white">
              <fa-icon [icon]="faChevronRight" [flip]="'horizontal'" iconLeft></fa-icon>Zurück
            </bic-button>
            <bic-button (onClick)="accordion.open(2)"
                        [disabled]="nextDisabledStep2">Weiter
              <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
            </bic-button>
          </div>
        </bic-accordion-body>
      </bic-accordion-element>

      <bic-accordion-element (opened)="expandedElement = 2" (closed)="expandedElement = null">
        <bic-accordion-header>
          <div><span>3. Zeitplan</span></div>
        </bic-accordion-header>
        <bic-accordion-body>
          <ng-container *ngTemplateOutlet="timeData"></ng-container>
          <div class="flex flex-row justify-end items-center gap-4 pt-5">
            <bic-button (onClick)="accordion.open(1)" buttonType="white">
              <fa-icon [icon]="faChevronRight" [flip]="'horizontal'" iconLeft></fa-icon>Zurück
            </bic-button>
            <bic-button (onClick)="createProject()"
                        [disabled]="createDisabled">Erstellen
              <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
            </bic-button>
          </div>
        </bic-accordion-body>
      </bic-accordion-element>
    </bic-accordion>

    <ng-template #generalData>
      <form [formGroup]="generalForm" class="pt-2">
        <div class="flex flex-row justify-between">
          @if (project) {
<app-project-image-upload [(image)]="project.image" [showOnly]="!editImagePermission"
                                    [project]="project"></app-project-image-upload>
}

          <div class="flex flex-col w-full gap-6">
            <div class="flex flex-row gap-12">
              <bic-input [formControlName]="'name'" [label]="'Projektname *'" [required]="true" [maxLength]="64" [showX]="false"
                         [placeholder]="'Name eingeben'" [class]="create ? 'w-1/2' : 'w-full'"
                         [errorCondition]="generalForm.controls['name'].touched && generalForm.controls['name'].invalid"></bic-input>
              @if (create && organisationLoaded) {
<div [formGroup]="ownerForm" class="w-1/2">
                <bic-select [formControlName]="'ownerOrganisation'" [label]="'Projektbesitzer*in *'" class="w-full"
                            [placeholder]="'Person oder Organisation auswählen'">
                  <bic-dropdown-element [value]="-1">Persönlich ({{ user.firstName }} {{ user.lastName }})
                  </bic-dropdown-element>
                  @if (organisations.length > 0) {

                    @for (organisation of organisations; track organisation) {

                      <bic-dropdown-element [value]="organisation.id">{{ organisation.name }}</bic-dropdown-element>
                    
}
                  
}

                </bic-select>

              </div>
}
            </div>

            <div class="flex flex-row gap-12 justify-between">
              <bic-input [formControlName]="'projectIdIntern'" [label]="'Projekt-ID'" [placeholder]="'Projekt-ID eingeben'" [showX]="false" [maxLength]="32"
                         class="w-1/4"></bic-input>

              <bic-select formControlName="projectKind" [label]="'Bauprojektart'" [placeholder]="'Bauprojektart auswählen'"
                          class="w-1/4">
                @for (projectKind of projectKinds | keyvalue; track projectKind) {

                  <bic-dropdown-element [value]="projectKind.value">{{ projectKind.value | projectKind }}
                  </bic-dropdown-element>
                
}
              </bic-select>


              <bic-select [formControlName]="'isBIM'" [label]="'BIM Projekt ?*'" [placeholder]="'BIM Projekt auswählen'"
                          [required]="true" class="w-1/4">
                <bic-dropdown-element [value]="true">Ja</bic-dropdown-element>
                <bic-dropdown-element [value]="false">Nein</bic-dropdown-element>
              </bic-select>
              <bic-input [formControlName]="'software'" [label]="'Planungssoftware'" [showX]="false" [placeholder]="'Planungssoftware eingeben'" [maxLength]="32"
                         class="w-1/4"></bic-input>
            </div>
          </div>
        </div>
      </form>
    </ng-template>

    <ng-template #placeData>
      <form [formGroup]="placeForm" class="pt-2">
        <div class="flex flex-col">
          <div>
            <app-address-input
              formControlNameZipCode="zipCode"
              formControlNameCity="buildingPlace"
              formControlNameHouseNumber="houseNumber"
              [displayState]="false"
              [stateDisabled]="false"
              [displayPlotNumber]="false"
              [formGroup]="placeForm"></app-address-input>
          </div>
        </div>
      </form>
    </ng-template>

    <ng-template #timeData>
      <form [formGroup]="timeForm" class="flex flex-row justify-start items-center gap-12 pt-2">

        <bic-input bicDatepickerInput [iconStart]="faCalendarDays" [formControlName]="'beginPlanning'" [label]="'Planungsbeginn'" [showX]="false"
                   [placeholder]="'Datum auswählen'" class="w-1/2" [isDatepicker]="true"
                   [errorCondition]="timeForm.controls.beginPlanning.invalid"
                   (dateChange)="timeForm.get('beginPlanning')?.setValue($event)"></bic-input>
        <bic-input bicDatepickerInput [iconStart]="faCalendarDays" [formControlName]="'endPlanning'" [label]="'Planungsende'" [placeholder]="'Datum auswählen'" [showX]="false"
                   class="w-1/2" [isDatepicker]="true"
                   [errorCondition]="timeForm.controls.endPlanning.invalid"
                   (dateChange)="timeForm.get('endPlanning')?.setValue($event)"></bic-input>
        <bic-input bicDatepickerInput [iconStart]="faCalendarDays" [formControlName]="'startExecuting'" [label]="'Ausführungsbeginn'" [showX]="false"
                   [placeholder]="'Datum auswählen'" class="w-1/2" [isDatepicker]="true"
                   [errorCondition]="timeForm.controls.startExecuting.invalid"
                   (dateChange)="timeForm.get('startExecuting')?.setValue($event)"></bic-input>
        <bic-input bicDatepickerInput [iconStart]="faCalendarDays" [formControlName]="'endExecuting'" [label]="'Ausführungsende'" [showX]="false"
                   [placeholder]="'Datum auswählen'" class="w-1/2" [isDatepicker]="true"
                   [errorCondition]="timeForm.controls.endExecuting.invalid"
                   (dateChange)="timeForm.get('endExecuting')?.setValue($event)"></bic-input>

      </form>
      @if (scheduleErrorMessage(timeForm); as error) {
        <span class="text-xs text-red-500 pt-1">{{ error }}</span>
      }
    </ng-template>

  </div>
}
</div>

<ng-template #generalInfo>
  <form [formGroup]="generalInfoForm">
    <div class="flex flex-col justify-start gap-5">

      <!-- content row split into 3 columns-->
      <div class="flex flex-row justify-center pl-2 gap-16">

        <!-- project image -->
        <div class="flex flex-row justify-center items-center">
          @if (project) {
<app-project-image-upload [(image)]="project.image" [showOnly]="!editImagePermission"
                                    [project]="project"></app-project-image-upload>
}
        </div>

        <!-- inputs -->
        <div class="flex flex-row w-full justify-between gap-12">
          <!-- name and id column -->
          <div class="flex flex-col justify-between h-full w-1/2 gap-4">
            <bic-input [formControlName]="'name'" [label]="'Projektname *'" [placeholder]="'Name eingeben'" [maxLength]="64" class="w-full" [showX]="false"
                       [required]="true"
                       [errorCondition]="generalInfoForm.controls.name.touched && generalInfoForm.controls.name.invalid"></bic-input>
            <div class="flex flex-row gap-12">
              <bic-input [formControlName]="'projectIdIntern'" [label]="'Projekt-ID'" [placeholder]="'Projekt-ID eingeben'" [showX]="false" [maxLength]="32"
                         class="w-1/2"></bic-input>
              <bic-select formControlName="projectKind" [label]="'Bauprojektart'"
                          [placeholder]="'Bauprojektart auswählen'" [disabled]="!hasEditPermission" class="w-1/2">
                @for (projectKind of projectKinds | keyvalue; track projectKind) {

                  <bic-dropdown-element [value]="projectKind.value">{{ projectKind.value | projectKind }}
                  </bic-dropdown-element>
                
}
              </bic-select>
            </div>
          </div>

          <!-- owner and project kind column -->
          <div class="flex flex-col justify-between h-full w-1/2 gap-4">
            <bic-input [value]="stateConfigService.selectedProject?.owner ?? ''" [label]="'Projektbesitzer*in'" [placeholder]="'Person oder Organisation auswählen'" [showX]="false"
                       class="w-full" [disabled]="true"></bic-input>
            <div class="flex flex-row gap-12">
              <bic-select [formControlName]="'isBIM'" [label]="'BIM Projekt?*'" [placeholder]="'BIM Projekt auswählen'" [disabled]="!hasEditPermission" class="w-1/2">
                <bic-dropdown-element [value]="true">Ja</bic-dropdown-element>
                <bic-dropdown-element [value]="false">Nein</bic-dropdown-element>
              </bic-select>
              <bic-input [formControlName]="'software'" [label]="'Planungssoftware'" [placeholder]="'Planungssoftware eingeben'" [showX]="false" [maxLength]="32"
                         class="w-1/2"></bic-input>

            </div>
          </div>
        </div>
      </div>

      <!-- delete and save buttons -->
      <div class="flex flex-row justify-end gap-4">
        <!-- LÖSCHEN BUTTON (Nur für Admins / Ersteller sichtbar) -->
        @if (canDeleteProject) {
<div class="inline-block">
          <bic-button (onClick)="openDeleteDialog()" buttonType="white">
            Löschen
          </bic-button>
        </div>
}

        <!-- SPEICHERN BUTTON -->
        @if (!hasEditPermission) {
<div tooltip="Keine Berechtigung" [tooltipDirection]="'top'" class="inline-block">
          <bic-button (onClick)="save()" [disabled]="true">
            Speichern
          </bic-button>
        </div>
}
        @if (hasEditPermission) {
<div class="inline-block">
          <bic-button (onClick)="save()" [disabled]="saveDisabled">
            Speichern
          </bic-button>
        </div>
}
      </div>

    </div>
  </form>
</ng-template>


<ng-template #addressInfo>

  <div class="flex flex-col justify-start w-full gap-5">
    <app-address-input
      formControlNameZipCode="zipCode"
      formControlNameCity="buildingPlace"
      formControlNameHouseNumber="houseNumber"
      [stateDisabled]="!hasEditPermission"
      [displayState]="false"
      [displayPlotNumber]="true"
      [formGroup]="addressInfoForm"></app-address-input>

    <div class="flex flex-row justify-end">
      <!-- SPEICHERN BUTTON -->
      @if (!hasEditPermission) {
<div tooltip="Keine Berechtigung" [tooltipDirection]="'top'" class="inline-block">
        <bic-button (onClick)="save()" [disabled]="true">
          Speichern
        </bic-button>
      </div>
}
      @if (hasEditPermission) {
<div class="inline-block">
        <bic-button (onClick)="save()" [disabled]="saveDisabled">
          Speichern
        </bic-button>
      </div>
}
    </div>
  </div>

</ng-template>


<ng-template #builderInfo>
  <form [formGroup]="builderInfoForm">
    <div class="flex flex-col justify-start w-full gap-12">

      <div class="flex flex-col justify-start w-full gap-5">

        <!-- second row -->
        <div class="flex flex-row justify justify-between w-full gap-[5%]">
          <bic-input bicDatepickerInput [iconStart]="faCalendarDays" formControlName="beginPlanning" [label]="'Planungsbeginn'" [placeholder]="'Datum auswählen'"
                     [isDatepicker]="true" [showX]="false"
                     [errorCondition]="builderInfoForm.controls.beginPlanning.invalid"
                     (dateChange)="builderInfoForm.get('beginPlanning')?.setValue($event)"
                     class="w-[25%]"></bic-input>
          <bic-input bicDatepickerInput [iconStart]="faCalendarDays" formControlName="endPlanning" [label]="'Planungsende'"
                     [placeholder]="'Datum auswählen'"
                     [isDatepicker]="true" [showX]="false"
                     [errorCondition]="builderInfoForm.controls.endPlanning.invalid"
                     (dateChange)="builderInfoForm.get('endPlanning')?.setValue($event)"
                     class="w-[25%]"></bic-input>
          <bic-input bicDatepickerInput [iconStart]="faCalendarDays" formControlName="startExecuting" [label]="'Ausführungsbeginn'" [placeholder]="'Datum auswählen'"
                     [isDatepicker]="true" [showX]="false"
                     [errorCondition]="builderInfoForm.controls.startExecuting.invalid"
                     (dateChange)="builderInfoForm.get('startExecuting')?.setValue($event)"
                     class="w-[25%]"></bic-input>
          <bic-input bicDatepickerInput [iconStart]="faCalendarDays" formControlName="endExecuting" [label]="'Ausführungsende'"
                     [placeholder]="'Datum auswählen'"
                     [isDatepicker]="true" [showX]="false"
                     [errorCondition]="builderInfoForm.controls.endExecuting.invalid"
                     (dateChange)="builderInfoForm.get('endExecuting')?.setValue($event)"
                     class="w-[25%]"></bic-input>
        </div>
        @if (scheduleErrorMessage(builderInfoForm); as error) {
          <span class="text-xs text-red-500">{{ error }}</span>
        }
        <!-- save button -->
        <div class="flex flex-row justify-end">
          <!-- SPEICHERN BUTTON -->
          @if (!hasEditPermission) {
<div tooltip="Keine Berechtigung" [tooltipDirection]="'top'" class="inline-block">
            <bic-button (onClick)="save()" [disabled]="true">
              Speichern
            </bic-button>
          </div>
}
          @if (hasEditPermission) {
<div class="inline-block">
            <bic-button (onClick)="save()" [disabled]="saveDisabled">
              Speichern
            </bic-button>
          </div>
}
        </div>

      </div>
    </div>
  </form>
</ng-template>

<ng-template #qualitySettingsInfo>
  <form [formGroup]="qualitySettingsInfoForm">
    @if (qualityParamsLoading) {
<div class="flex flex-col justify-start w-full gap-5">
      <div class="flex flex-row w-full justify-center items-center gap-2">
        <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
        <span class="text-sm font-medium text-gray-500">Prüfeinstellungen werden geladen...</span>
      </div>
    </div>
}

    @if (!qualityParamsLoading) {
<div class="flex flex-col justify-start w-full gap-5">
      <p class="text-sm text-gray-500">
        Hier legen Sie die Prüfeinstellungen für die Prüfregeln des All-Right Checks fest. Die Angaben werden
        bei jedem All-Right Check dieses Projekts verwendet. Fehlende Werte können Sie auch noch beim Ausführen
        eines All-Right Checks ergänzen.
      </p>

      <!-- create rows, 1 row per 2 quality params -->
      @for (parameterList of qualityParams; track parameterList) {
<div class="flex flex-row h-60[px] w-full gap-[5%]"
           [ngClass]="{'justify-start' : parameterList.length == 1, 'justify-between' : parameterList.length != 1}">

        @for (parameter of parameterList; track parameter) {

          @if (parameter.type == Parameter.TypeEnum.BOOL) {

            <bic-select #boolSelect [value]="qualityValue[parameter.value!]"
                        (valueChange)="updateQualityValue(parameter.value!, boolSelect.value)" [label]="parameter.name ?? ''" [placeholder]="'Ja/Nein'"
                        [disabled]="!hasEditPermission"
                        class="w-[45%]">
              <bic-dropdown-element [value]="true">Ja</bic-dropdown-element>
              <bic-dropdown-element [value]="false">Nein</bic-dropdown-element>
            </bic-select>
          
}

          @if (parameter.type == Parameter.TypeEnum.INT) {

            @if (parameter.value != 'building_class') {
<bic-input [value]="qualityValue[parameter.value!]"
                       (valueChange)="validateNumberInput($event, parameter.value!)"
                       [type]="'number'" [label]="parameter.name ?? ''" class="w-[45%]" [min]="0" [customStepSize]="true" [showX]="false"
                       [stepSize]="1" [placeholder]="'Anzahl eingeben'"
                       [disabled]="!hasEditPermission"></bic-input>
}
            @if (parameter.value == 'building_class') {
<bic-select
             
              #buildingClassSelect
              [value]="qualityValue[parameter.value!]"
              (valueChange)="updateQualityValue(parameter.value!, buildingClassSelect.value)"
              [label]="parameter.name ?? ''" [placeholder]="'Gebaeudeklasse auswählen'"
              [disabled]="!hasEditPermission"
              class="w-[45%]">
              <bic-dropdown-element [value]="1">1</bic-dropdown-element>
              <bic-dropdown-element [value]="2">2</bic-dropdown-element>
              <bic-dropdown-element [value]="3">3</bic-dropdown-element>
              <bic-dropdown-element [value]="4">4</bic-dropdown-element>
              <bic-dropdown-element [value]="5">5</bic-dropdown-element>
            </bic-select>
}
          
}

          @if (parameter.type == Parameter.TypeEnum.ENUM) {

            <bic-select #enumSelect [value]="qualityValue[parameter.value!]"
                        (valueChange)="updateQualityValue(parameter.value!, enumSelect.value)" [label]="parameter.name ?? ''" [placeholder]="'Auswählen'"
                        [disabled]="!hasEditPermission"
                        class="w-[45%]">
              @for (value of parameter.enums; track value) {
<bic-dropdown-element [value]="value.value">{{ value.name }}
              </bic-dropdown-element>
}
            </bic-select>
          
}

          @if (parameter.type == Parameter.TypeEnum.FLOAT || parameter.type == null) {

            <!-- type="text": ein Zahlenfeld verschluckt „-" und „," still; geprüft wird per decimalInputValidator. -->
            <div class="flex flex-col w-[45%]">
              <bic-input [value]="decimalInputText(parameter.value!)"
                         (valueChange)="validateDecimalInput($event, parameter.value!)"
                         [label]="parameter.name ?? ''" [showX]="false"
                         [placeholder]="'z.B. -2,50'" class="w-full" [type]="'text'"
                         [errorCondition]="hasDecimalError(parameter.value!)"
                         [disabled]="!hasEditPermission"></bic-input>
              @if (hasDecimalError(parameter.value!)) {
                <span class="block mt-2 text-sm text-red-500">Bitte eine Zahl eingeben, z. B. -2,50 (Komma oder Punkt als Dezimaltrennzeichen).</span>
              }
            </div>
          
}


        
}

      </div>
}

      <!-- save button -->
      <div class="flex flex-row justify-end">
        <!-- SPEICHERN BUTTON -->
        @if (!hasEditPermission) {
<div tooltip="Keine Berechtigung" [tooltipDirection]="'top'" class="inline-block">
          <bic-button (onClick)="save()" [disabled]="true">
            Speichern
          </bic-button>
        </div>
}
        @if (hasEditPermission) {
<div class="inline-block">
          <bic-button (onClick)="save()" [disabled]="saveDisabled">
            Speichern
          </bic-button>
        </div>
}
      </div>

    </div>
}
  </form>
</ng-template>
